import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-scroll";
import {Animated} from "react-animated-css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle as farCircle } from "@fortawesome/free-regular-svg-icons";
import autonomousPricing from "../../static/images/solutions/pricing.svg";
import assetOptimization from "../../static/images/solutions/asset_optimization.svg";
import automateDecisions from "../../static/images/solutions/automate_operational_decisions.svg";
import assetManagement from "../../static/images/solutions/asset_management.svg";
import customerSegmentation from "../../static/images/solutions/customer_segmentation.svg";
import predictiveMaintenance from "../../static/images/solutions/predictive_maintenance.svg";
import injuryPrevention from "../../static/images/solutions/injury_prevention.svg";
import demandForecasting from "../../static/images/solutions/demand_forecasting.svg";
import anomalyDetection from "../../static/images/solutions/anomaly_detection.svg";
import dataAccuracy from "../../static/images/solutions/data_accuracy.svg";
import Layout from "../components/layout";
import solutionsHeaderImage from "../../static/images/solutions/solutions_page_graphics.png";

import '../styles/style.scss';
// import uxAI from "../../static/images/homepage/UX_AI.jpg";

import { assignActiveElement, changeSlideInClass } from "../utilities/elementUtilities";

class Solutions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anomaly_detection: -20,
      demand_forecasting: 50,
      animationInDelayValue: 0
    };
    this.changeOffset = this.changeOffset.bind(this);
    this.handleScroll= this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    window.addEventListener("resize", this.changeOffset);
    this.handleScroll();
    this.changeOffset();
  }

  handleScroll = () => {
    var sectionList = [
      document.getElementById('autonomous-pricing'),
      document.getElementById('mobile-asset-optimization'),
      document.getElementById('asset-management'),
      document.getElementById('automating-operations'),
      document.getElementById('customer-behavior-sim'),
      document.getElementById('predictive-maintenance'),
      document.getElementById('injury-prediction'),
      document.getElementById('demand-forecasting'),
      document.getElementById('anomaly-detection'),
      document.getElementById('data-accuracy'),
    ];
    assignActiveElement(sectionList);

    changeSlideInClass();

  }

  changeOffset = () => {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width >= 768 && width <= 991) {
      this.setState({ 
        demand_forecasting: -10,
      });
    } else if (width > 991) {
      this.setState({ 
        demand_forecasting: -70
      });
    } else {
      this.setState({ 
        demand_forecasting: 50
      });
    }
  }

  render(){
    return(  
      <Layout layoutClassName="solutions-page">
        <div className="side-dots-nav">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="s-ensure-your-success"
                  // to="we-build-bespoke-software"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="autonomous-pricing"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="mobile-asset-optimization"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="asset-management"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="automating-operations"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="customer-behavior-sim"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="predictive-maintenance"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="injury-prediction"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item">
              <Link
                  activeClass="active"
                  to="demand-forecasting"
                  spy={true}
                  smooth={true}
                  offset={this.state.demand_forecasting}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-smaller-screens2">
              <Link
                  activeClass="active"
                  to="anomaly-detection"
                  spy={true}
                  smooth={true}
                  offset={this.state.anomaly_detection}
                  duration={500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
            <li className="nav-item hide-on-smaller-screens">
              <Link
                  activeClass="active"
                  to="data-accuracy"
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration= {500}
                  className="dot-link"
              >
                <FontAwesomeIcon icon={faCircle} className="solidCircle"/>
                <FontAwesomeIcon icon={farCircle} className="regularCircle"/>
              </Link>
            </li>
          </ul>
        </div>
        <Container id="solutions-container" className="full-container">
          <section id="s-ensure-your-success" className="section solutions-heading full first">
            <Row>
              <Col sm="12" lg="6" className="solutions-heading-img-holder heading-img-holder">
                <img src={solutionsHeaderImage} alt="check" className="" />
              </Col>
              <Col sm="12" lg="6" className="solutions-heading-caption-column">
                <Row className="solutions-heading-caption">
                  <Col sm="12" className="solutions-heading-header">
                    <p className="header-right">We serve clients in many industries.</p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </section>
          {/* <section id="we-build-bespoke-software" className="section section-we-build full first">
            <Row>
              <Col sm="12" lg="6" className="we-build-bespoke-img-holder">
                <img src={uxAI} alt="check" className="" />
              </Col>
              <Col sm="12" lg="6" className="we-build-bespoke-caption-column">
                <Row className="we-build-bespoke-caption">
                  <Col sm="12" className="we-build-bespoke-header">
                    <p>AI is overhyped.</p>
                  </Col>
                  <Col sm="12">
                    <p className="we-build-bespoke-subheader">
                      The products we build focus on an intuitive and seamless user experience. They solve problems with elegance, requiring the least time and effort and always put the user experience first.
                    </p>
                    <p className="we-build-bespoke-subheader">
                      We will build the AI only if there is sufficient data and it improves the human experience.
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </section> */}
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="autonomous-pricing" className="section solutions autonomous-pricing">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={autonomousPricing} alt="Autonomous Pricing" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Autonomous pricing</p>
                  <p className="subheading">We have years of experience in identifying underlying drivers of supply and demand to create pricing strategies. We work with you to understand your pricing processes, identify available data, and build additional data capturing tools. We then create the simulator that ingest all the data, craft the appropriate algorithm, and provide a price demand forecast and a price recommendation. The simulator will compare forecasts to actuals, and use AI to constantly refine the impact of certain variables to reduce deviation and increase forecast accuracy.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="mobile-asset-optimization" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={assetOptimization} alt="Mobile Asset Optimization" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Mobile asset optimization</p>
                  <p className="subheading">Most businesses have mobile assets which include trucks, cars, airplanes, locomotives, etc. Automating and optimizing routes, personnel and asset schedules, and maintenance schedules reduces the labor hours needed to manually manage these functions and help ensure that business objectives are constantly maximized. We have the knowledge and industry experience to build AI which automates these manual processes.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="asset-management" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={assetManagement} alt="Asset Management" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Asset management</p>
                  <p className="subheading">Buying and decommissioning assets can be a significant planning exercise for any large operation and is critical in ensuring uninterrupted service to customers. We utilize ingest.bld.ai to organize all of the data for your assets, understand decommissioning timelines, and create a decommissioning plan. Simulate.bld.ai then allows clients to create multiple scenarios and get a thorough understanding of the impact of their recommended changes.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="automating-operations" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={automateDecisions} alt="Automating Operational Decisions" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Automating operations</p>
                  <p className="subheading">Many times operational decisions are repetitive. We build the simulator that integrates the IoT and ingests billions of data points to understand the current state of the business and creates a forecast of the future state. We then apply AI to optimize and automate the entire system's decisions for every part of the process including inventory management, processing capacity, quality control, and scheduling.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="customer-behavior-sim" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={customerSegmentation} alt="Customer Behavior Simulation" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Customer behavior simulation</p>
                  <p className="subheading">We create the simulator that can identify and segment groups of customers to understand what offerings and incentives drive customer behavior and measure the impact. Additionally, we build disruption modeling capabilities which allows you to simulate and forecast the impact of potential offerings on the population. This provides a much quicker understanding of new ideas and avoids the potential negative impact of real world testing.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="predictive-maintenance" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={predictiveMaintenance} alt="Predictive Maintenance" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Preventive maintenance</p>
                  <p className="subheading">Preventive maintenance is a fundamental of any large fleets of fixed and mobile assets. We leverage IoT platforms (e.g., Azure, AWS, GCP) to monitor machinery performance in real time and use the data to estimate time to failure, identify failure indicators, and automatically notify maintenance crews of potential concerns.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="injury-prediction" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={injuryPrevention} alt="Injury Prediction" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Injury prediction</p>
                  <p className="subheading">Changes in safety performance can be attributed to a number of factors. We have experience building software that can gather and normalize safety data to understand if a change in performance has occurred and notify the relevant stakeholders. Armed with this insight, decision makers can make the precise changes necessary to provide a safe working environment that people deserve.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="demand-forecasting" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={demandForecasting} alt="Demand Forecasting" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Demand forecasting</p>
                  <p className="subheading">A demand forecasting engine is a cornerstone of any advanced pricing and marketing engine. A demand forecasting simulator allows leaders to change the input variables, and observe the impact across their products and services line. Your team can project scenarios informed by the latest movements in the market and create an outlook that can inform not only your sales team, but also your risk and operations teams so they can plan with more foresight.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="anomaly-detection" className="section solutions">
              <Row>
                <Col xs={12} md={3} className="image">
                  <img src={anomalyDetection} alt="Supply Chain Anomaly Detection" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Supply chain anomaly detection</p>
                  <p className="subheading">Supply chains are a source of millions of data points. The negative impact of changes to complex supply chains are well known by business and operations leaders. We use real time supply chain data and forecast the impact of any changes to downstream processes. This insight allows our clients the visibility to manage through these inevitable changes and minimize business disruption.</p>
                </Col>
              </Row>
            </section>
          </Animated>
          <Animated animationIn="slideInUp" animationOut="slideOutDown" isVisible={true} animationInDelay={this.state.animationInDelayValue}>
            <section id="data-accuracy" className="section solutions">
              <Row className="last-solution">
                <Col xs={12} md={3} className="image">
                  <img src={dataAccuracy} alt="Data Accuracy" />
                </Col>
                <Col xs={12} md={9} className="content">
                  <p className="heading">Data accuracy</p>
                  <p className="subheading">AI is only as good as the data it ingests. We monitor real time the integrity of your data so that outliers can be automatically identified and immediately rectified. However, there are times when outliers provide an indication that the fundamental assumptions of a business are changing. The simulators we build provide business leaders the insight to understand these changes and make the necessary decisions to stay ahead of the competition.</p>
                </Col>
              </Row>
            </section>
          </Animated>
        </Container>
      </Layout>
    );
  }
}

export default (Solutions);